import { useCallback, useEffect, useState } from 'react';
import { getStats } from './statsService';

/** Load the KPI stat docs once; exposes { stats, loading, error, reload }. */
export default function useStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(() => {
    setLoading(true);
    getStats()
      .then((s) => {
        setStats(s);
        setError(null);
      })
      .catch((e) => setError(e.message || String(e)))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { stats, loading, error, reload };
}
